<script lang="ts" setup>
import type { Component } from 'vue'

interface Props {
    icon: Component
    label: string
    amount?: string | number | null
    type: 'main' | 'bonus'
}

const { icon, label, amount = null, type } = defineProps<Props>()
</script>

<template>
    <div class="wallet-item" :class="`wallet-item-${type}`">
        <div :class="type === 'main' ? 'wallet-icon' : 'bonus-wallet-icon'">
            <component :is="icon" />
        </div>
        <div class="wallet-label">
            {{ label }}
        </div>
        <div v-if="amount !== null" class="wallet-amount">
            {{ amount }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/common/variables.scss" as *;

.wallet-item {
    display: flex;
    width: 100%;
    align-items: center;
    border-radius: 8px;
    background-color: rgb(255, 255, 255, 10%);
    gap: 8px;
}

.wallet-item-main {
    gap: 4px;

    .wallet-icon {
        width: 16px;
        height: 16px;
    }

    .wallet-amount {
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
    }
}

.wallet-item-bonus {
    gap: 4px;

    .bonus-wallet-icon {
        width: 16px;
        height: 16px;
    }

    .wallet-amount {
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
    }
}

.wallet-icon,
.bonus-wallet-icon {
    display: flex;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.wallet-label {
    flex: 1 0 0;
    color: $bank-color;
    font-size: 14px;
    font-weight: 500;
}

.wallet-amount {
    margin-left: auto;
    color: $bank-color;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
}
</style>
